<template>
  <v-row id="search-post-code" class="my-4" no-gutters>
    <v-col cols="8">
      <v-text-field
        background-color="#F0F0F0"
        :dense="dense"
        :error-messages="errorMessage"
        label="Search by postcode"
        outlined
        v-model="postCode"
      >
      </v-text-field>
    </v-col>
    <v-col :cols="allowExportAll && !pdfURLError ? 2 : 4" class="pl-sm-2">
      <v-btn
        class="p-btn"
        :class="{ 'p-btn-dense': dense }"
        color="secondary"
        :loading="fetching"
        rounded
        :x-small="$vuetifyDisplay.xsOnly"
        @click="searchPostCode(postCode)"
      >
        <v-icon>mdi-magnify</v-icon>
        <span v-if="!$vuetifyDisplay.xsOnly">Search</span>
      </v-btn>
    </v-col>
    <v-col v-if="allowExportAll && !pdfURLError" cols="2" class="pl-sm-2">
      <v-btn
        class="p-btn"
        color="primary"
        rounded
        :class="{ 'p-btn-dense': dense }"
        :href="postCodeZonesPDFURL"
        target="_blank"
        :x-small="$vuetifyDisplay.xsOnly"
      >
        <v-icon>mdi-file-pdf-box</v-icon>
        <span v-if="!$vuetifyDisplay.xsOnly">{{ exportAllLabel }}</span>
      </v-btn>
    </v-col>
    <v-col v-if="postCodeSearched" cols="12" class="text-center">
      <div class="mt-4 mt-sm-n4">
        <p v-if="postCodeZone" class="g-heading-s g-bold p-search-success pa-2">
          ZONE {{ postCodeZone }}
          <v-icon
            class="pl-1 pb-1 p-search-success"
            @click="postCode = postCodeZone = postCodeSearched = null"
            >mdi-close-circle-outline</v-icon
          >
        </p>
        <p v-else class="g-heading-s g-bold p-search-error pa-2">
          Zone not found for this Postcode
          <v-icon
            class="pl-1 pb-1 p-search-error"
            @click="postCode = postCodeZone = postCodeSearched = null"
            >mdi-close-circle-outline</v-icon
          >
        </p>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import { getPostCodeZonesPDF, lookupPostCode } from '@/services/dataMaintenance'

export default {
  props: {
    dense: {
      type: Boolean,
      default: false
    },
    allowExportAll: {
      type: Boolean,
      default: true
    },
    exportAllLabel: {
      type: String,
      default: 'View All'
    }
  },

  data: () => ({
    fetching: false,
    postCode: null,
    postCodeZone: null,
    postCodeSearched: false,
    postCodeZonesPDFURL: '',
    pdfURLError: false
  }),

  mounted() {
    this.getZonesPDF()
  },

  computed: {
    errorMessage() {
      return (
        (!!this.postCode &&
          this.invalidPostCode(this.postCode) &&
          'Invalid postcode.') ||
        null
      )
    }
  },

  methods: {
    invalidPostCode(postCode) {
      return !/^[0-9]{4}$/.test(postCode)
    },

    searchPostCode(postCode) {
      this.fetching = true
      lookupPostCode(postCode)
        .then((response) => {
          this.postCodeZone = response.zoneCode
        })
        .catch(() => {
          this.postCodeZone = null
        })
        .finally(() => {
          this.postCodeSearched = true
          this.fetching = false
        })
    },

    getZonesPDF() {
      getPostCodeZonesPDF()
        .then((response) => {
          this.postCodeZonesPDFURL = response.url
          this.pdfURLError = false
        })
        .catch(() => {
          this.pdfURLError = true
        })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/_variables.scss';

#search-post-code {
  .p-btn {
    text-transform: none;
    font-size: 16px;
    font-weight: bold;
    width: 100%;
    height: 56px;
    &-dense {
      height: 40px;
    }
  }
  .p-search-success {
    background: $green-color-bg;
    color: $green-color;
    border-radius: 3px;
  }
  .p-search-error {
    background: $red-color-bg;
    color: $red-color;
    border-radius: 3px;
  }
}

@media only screen and (min-width: 960px) {
  #search-post-code {
    .p-search-success,
    .p-search-error {
      border-radius: 5px;
    }
  }
}
</style>
